module.exports = __webpack_public_path__ + "img/montaj.c62db9f8.jpg";